/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class PricingPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(pricingPopup) {
    pricingPopup.setAttribute(
      'univ-semantic-name',
      this.pathQueryMap.pathMap.univ
    );
    pricingPopup.setAttribute('view', 'pricing');
  }
}
